<template>
  <div id="settings-wrapper">
    <v-card-text class="v-settings">
      <strong class="mb-3 d-inline-block">{{ $t('page-setting') }}</strong>

      <v-item-group v-model="color">
        <v-item
          v-for="color in colors"
          :key="color"
          :value="color"
        >
          <template v-slot="{ active, toggle }">
            <v-avatar
              :class="active && 'v-settings__item--active'"
              :color="color"
              class="v-settings__item"
              size="25"
              @click="toggle"
            />
          </template>
        </v-item>
      </v-item-group>

      <v-divider class="my-4 secondary" />

      <v-row
        align="center"
        no-gutters
      >
        <v-col cols="auto">
          {{ $t('dark-Mode') }}
        </v-col>

        <v-spacer />

        <v-col cols="auto">
          <v-switch
            v-model="dark"
            class="ma-0 pa-0"
            color="secondary"
            hide-details
          />
        </v-col>
      </v-row>

      <v-divider class="my-4 secondary" />

      <v-row
        align="center"
        no-gutters
      >
        <v-col cols="auto">
          {{ $t('RTL_Mode') }}
        </v-col>

        <v-spacer />

        <v-col cols="auto">
          <v-switch
            v-model="rtl"
            class="ma-0 pa-0"
            color="secondary"
            hide-details
          />
        </v-col>
      </v-row>

<!--      <v-divider class="my-4 secondary" />-->
<!--      <v-row-->
<!--        align="center"-->
<!--        no-gutters-->
<!--      >-->
<!--        <v-col cols="auto">-->
<!--          {{ $t('hoverMenuMode') }}-->
<!--        </v-col>-->

<!--        <v-spacer />-->

<!--        <v-col cols="auto">-->
<!--          <v-switch-->
<!--            v-model="hoverMenu"-->
<!--            class="ma-0 pa-0"-->
<!--            color="secondary"-->
<!--            hide-details-->
<!--          />-->
<!--        </v-col>-->
<!--      </v-row>-->

      <v-divider class="my-4 secondary" />
      <v-row
        align="center"
        no-gutters
      >
        <v-col cols="auto">
          {{ $t('appBarsOpacity') }}
        </v-col>

        <v-spacer />

        <v-col cols="auto">
          <v-switch
            v-model="appBarsOpacity"
            class="ma-0 pa-0"
            color="secondary"
            hide-details
          />
        </v-col>
      </v-row>

      <v-divider class="my-4 secondary" />
      <v-row
        align="center"
        no-gutters
      >
        <v-col cols="auto">
          {{ $t('language') }}
        </v-col>

        <v-spacer />

        <v-col cols="auto">
          <language v-model="lang" />
        </v-col>
      </v-row>
      <v-divider class="my-4 secondary" />

      <v-row
        align="center"
        no-gutters
      >
        <v-col cols="auto">
          {{ $t('date-type') }}
        </v-col>

        <v-spacer />

        <v-col cols="auto">
          {{ ($store.state.date_locale == 'fa,en' ? $t('jalali') : $t('gregorian')) }}
        </v-col>
      </v-row>
      <v-divider class="my-4 secondary" />

      <v-row
        align="center"
        no-gutters
      >
        <v-col cols="auto">
          {{ $t('background') }}
        </v-col>

        <v-spacer />

        <background />
      </v-row>
    </v-card-text>
  </div>
</template>

<script>
  // Mixins
  import Proxyable from 'vuetify/lib/mixins/proxyable'
  import { mapMutations, mapState } from 'vuex'
  import General from '../../../../Mixins/general'
  import Language from './LanguageBar'
  import Background from './Background'
  export default {
    name: 'DashboardCoreSettings',
    components: {
      Language,
      Background,
    },

    mixins: [Proxyable, General],
    data: () => ({
      rtl: true,
      settingBtn: true,
      origin: 'top right',
      color: '#E91E63',
      hoverMenu: null,
      appBarsOpacity: null,
      lang: null,
      dark: false,
      styleObject: {
        color: 'red',
        fontSize: '13px',
      },
      colors: [
        '#0066FF',
        '#7c4dff',
        '#00CAE3',
        '#4CAF50',
        '#ff9800',
        '#E91E63',
        '#FF5252',
      ],
      image: 'https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-1.jpg',
      images: [
        'https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-1.jpg',
        'https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-2.jpg',
        'https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-3.jpg',
        'https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-4.jpg',
      ],
      menu: false,
      saveImage: '',
      showImg: true,
    }),
    computed: {
      ...mapState(['barImage']),
    },

    watch: {
      menu (val) {
        // this.settingBtn = !val
      },
      color (val) {
        this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary = val
        var storage = JSON.parse(localStorage.getItem('token'))
        storage.init.theme_color.value = val
        localStorage.setItem('token', JSON.stringify(storage))
        this.store()
      },
      showImg (val) {
        if (!val) {
          this.saveImage = this.barImage
          this.setBarImage('')
        } else if (this.saveImage) {
          this.setBarImage(this.saveImage)
          this.saveImage = ''
        } else {
          this.setBarImage(val)
        }
      },
      image (val) {
        this.setBarImage(val)
      },
      rtl (val) {
        this.origin = 'top left'
        this.$vuetify.rtl = val
        var storage = JSON.parse(localStorage.getItem('token'))
        storage.init.rtl.value = val
        localStorage.setItem('token', JSON.stringify(storage))
        this.store()
        this.modifyVuetifyApplication()
      },
      hoverMenu (val) {
        this.origin = 'top left'
        var storage = JSON.parse(localStorage.getItem('token'))
        if (storage.init.hoverMenu) {
          storage.init.hoverMenu.value = val
        } else {
          var hover = { value: val }
          storage.init.hoverMenu = hover
        }
        this.$store.commit('SET_HOVERMENU', val)
        localStorage.setItem('token', JSON.stringify(storage))
        this.store()
        this.modifyVuetifyApplication()
      },
      appBarsOpacity (val) {
        this.origin = 'top left'
        var storage = JSON.parse(localStorage.getItem('token'))
        if (storage.init.appBarsOpacity) {
          storage.init.appBarsOpacity.value = val
        } else {
          var appBarsOpacity = { value: val }
          storage.init.appBarsOpacity = appBarsOpacity
        }
        this.$store.commit('SET_APPBARSOPACITY', val)
        localStorage.setItem('token', JSON.stringify(storage))
        this.store()
      },
      dark (val) {
        this.origin = 'top left'
        this.$vuetify.theme.dark = val
        var storage = JSON.parse(localStorage.getItem('token'))
        storage.init.dark.value = val
        localStorage.setItem('token', JSON.stringify(storage))
        this.store()
      },
      lang (val) {
        if (this.lang !== undefined) {
          this.store()
        }
      },
    },

    methods: {
      ...mapMutations({
        setBarImage: 'SET_BAR_IMAGE',
      }),
      store () {
        var app = this
        app.$axios.post(this.$endpoint + 'setting', this.$data)
          .then(res => {
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
      },
    },
    mounted () {
      var store = this.$store.state
      this.color = store.theme_color
      this.rtl = store.rtl
      this.dark = store.dark
      this.hoverMenu = store.hoverMenu
      this.appBarsOpacity = store.appBarsOpacity
    },
  }
</script>

<style lang="sass">
  .v-settings
    .v-item-group > *
      cursor: pointer

    &__item
      border-width: 3px
      border-style: solid
      border-color: transparent !important

      &--active
        border-color: #00cae3 !important
</style>
<style>
  .rtl{
    left : -55px
  }
  .ltr{
    right : -55px
  }
</style>
